import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const timetable: ApiFunc<`${typeof API.TIMETABLE}`, 'get'> = data =>
  instance.get(API.TIMETABLE, { params: data })

// export const timetableUpdated: ApiFunc<`${typeof API.TIMETABLE_UPDATED}`, 'get'> = data =>
//   instance.get(API.TIMETABLE_UPDATED, { params: data })

export const timetableAll: ApiFunc<`${typeof API.TIMETABLE_ALL}`, 'get'> = data =>
  instance.get(API.TIMETABLE_ALL, { params: data })

// export const timetableGenerate: ApiFunc<`${typeof API.TIMETABLE_GENERATE_UPDATED}`, 'post'> = data =>
//   authorizedInstance.post(API.TIMETABLE_GENERATE_UPDATED, data)

export const timetableGenerateUpdated: ApiFunc<`${typeof API.TIMETABLE_GENERATE_UPDATED}`, 'post'> = data =>
  instance.post(API.TIMETABLE_GENERATE_UPDATED, data)

export const timetableUpdateStatus: ApiFunc<`${typeof API.TIMETABLE_UPDATE_STATUS}`, 'put'> = data =>
  instance.put(API.TIMETABLE_UPDATE_STATUS, data)

export const timetableHoursReport: ApiFunc<`${typeof API.TIMETABLE_HOURS_REPORT}`, 'post'> = data =>
  instance.post(API.TIMETABLE_HOURS_REPORT, data, { responseType: 'blob' })
